import getBasePath from '../functions/api-resource';

const basePath = getBasePath('usuario', 'eventosusuario');

const acessoUsuarioActions = {
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}&idUsuario={userid}&startDate={dateini}&endDate={dateend}` },
};

export default (resource) => resource(`${basePath}`, {}, acessoUsuarioActions);
